const API_URL = process.env.REACT_APP_API_URL || 'http://40.117.79.165:8000';

// Obtener el token del localStorage
export const getToken = () => {
  return localStorage.getItem('access_token');
};

// Headers con autenticación
export const getAuthHeaders = () => {
  const token = getToken();
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
};

// Login con usuario y contraseña
export const loginWithCredentials = async (username, password) => {
  const formData = new URLSearchParams();
  formData.append('username', username);
  formData.append('password', password);

  const response = await fetch(`${API_URL}/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: formData,
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al iniciar sesión');
  }

  return response.json();
};

// Login con Google
export const loginWithGoogle = async (googleToken) => {
  const response = await fetch(`${API_URL}/auth/google`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token: googleToken }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al autenticar con Google');
  }

  return response.json();
};

// Obtener datos del usuario actual
export const getCurrentUser = async () => {
  const response = await fetch(`${API_URL}/usuarios/me`, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error('Error al obtener datos del usuario');
  }

  return response.json();
};

// Verificar si el token es válido
export const verifyToken = async () => {
  try {
    await getCurrentUser();
    return true;
  } catch {
    return false;
  }
};
